module.exports = __webpack_public_path__ + "img/policy-default02.e8b4c9d4.jpg";